import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, color = "#fff" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_59459)">
        <path
          d="M2.25 14.25C3.27613 13.6576 4.44013 13.3457 5.625 13.3457C6.80987 13.3457 7.97387 13.6576 9 14.25C10.0261 13.6576 11.1901 13.3457 12.375 13.3457C13.5599 13.3457 14.7239 13.6576 15.75 14.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.25 4.50003C3.27613 3.9076 4.44013 3.5957 5.625 3.5957C6.80987 3.5957 7.97387 3.9076 9 4.50003C10.0261 3.9076 11.1901 3.5957 12.375 3.5957C13.5599 3.5957 14.7239 3.9076 15.75 4.50003"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.25 4.5V14.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 4.5V14.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 4.5V14.25"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_59459">
          <rect width={width} height={height} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
